//src/pages/Withdraw.jsx

import { useCallback, useEffect, useState } from "react";
import API from "../services/api";

const Withdraw = () => {
  const [history, setHistory] = useState([]);
  const [analytics, setAnalytics] = useState(null);

  const [amount, setAmount] = useState("");
  const [bank, setBank] = useState("");
  const [account, setAccount] = useState("");
  const [name, setName] = useState("");

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const token = localStorage.getItem("token");

  // =========================
  // LOAD DATA (FIXED FOR ESLINT)
  // =========================
  const loadData = useCallback(async () => {
    try {
      const [historyRes, analyticsRes] = await Promise.all([
        API.get("/withdraw/history", {
          headers: { Authorization: `Bearer ${token}` },
        }),
        API.get("/withdraw/creator/analytics", {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      setHistory(historyRes.data);
      setAnalytics(analyticsRes.data);
    } catch (err) {
      console.error("Failed to load withdraw data:", err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // =========================
  // WITHDRAW REQUEST
  // =========================
  const handleWithdraw = async () => {
    if (!amount || !bank || !account || !name) {
      return alert("Fill all fields");
    }

    if (Number(amount) <= 0) {
      return alert("Invalid amount");
    }

    if (Number(amount) > (analytics?.available_balance || 0)) {
      return alert("Insufficient balance");
    }

    try {
      setSubmitting(true);

      await API.post(
        "/withdraw",
        {
          amount: Number(amount),
          bank_name: bank,
          account_number: account,
          account_name: name,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      alert("✅ Withdraw request submitted");

      setAmount("");
      setBank("");
      setAccount("");
      setName("");

      await loadData();
    } catch (err) {
      alert(err?.response?.data?.detail || "Failed to submit request");
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <h2>Loading...</h2>;

  return (
    <div className="container">
      <h1>💸 Withdraw</h1>

      {/* BALANCE */}
      <div className="card">
        <h3>Available Balance</h3>
        <h2>₦{analytics?.available_balance || 0}</h2>
      </div>

      {/* FORM */}
      <div className="card">
        <h3>Request Withdrawal</h3>

        <input
          placeholder="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="input"
        />

        <input
          placeholder="Bank Name"
          value={bank}
          onChange={(e) => setBank(e.target.value)}
          className="input"
        />

        <input
          placeholder="Account Number"
          value={account}
          onChange={(e) => setAccount(e.target.value)}
          className="input"
        />

        <input
          placeholder="Account Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="input"
        />

        <button
          className="button"
          onClick={handleWithdraw}
          disabled={submitting}
        >
          {submitting ? "Processing..." : "Withdraw"}
        </button>
      </div>

      {/* HISTORY */}
      <div className="card">
        <h3>📜 Withdrawal History</h3>

        {history.length === 0 && (
          <p>No withdrawals yet — your payouts will appear here</p>
        )}

        {history.map((w) => (
          <div
            key={w.id}
            style={{
              borderBottom: "1px solid #eee",
              padding: 10,
            }}
          >
            <p>💰 ₦{w.amount}</p>

            <p>
              {w.bank_name} •{" "}
              {w.account_number
                ? w.account_number.slice(-4).padStart(w.account_number.length, "*")
                : "****"}
            </p>

            <p style={{ fontSize: 12, opacity: 0.6 }}>
              Requested: {new Date(w.created_at).toLocaleString()}
            </p>

            {/* SAFE processed_at */}
            {w.processed_at && (
              <p style={{ fontSize: 12, opacity: 0.6 }}>
                Processed: {new Date(w.processed_at).toLocaleString()}
              </p>
            )}

            <p>
              Status:{" "}
              <span
                style={{
                  color:
                    w.status === "approved"
                      ? "green"
                      : w.status === "pending"
                      ? "orange"
                      : "red",
                }}
              >
                {w.status}
              </span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Withdraw;